/*
 * @Author: your name
 * @Date: 2021-08-06 13:46:48
 * @LastEditTime: 2023-10-20 13:43:04
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\api\channelApi\shopManageApi.js
 */
/**
 * Physical Shop Manage : 门店管理
 */
import { generate } from '@/utils/request';
const config = {
  prefix: '/schl/v1/{organizationId}',
  items: [
    /**
     * 查询列表
     */
    { key: 'getAllShopPage', url: '/shop/page', method: 'POST',loadingHide: true, },
  ],
};

export default {
  ...generate(config),
};
